import * as React from 'react';
import Text from 'antd/lib/typography/Text';
import { useSidebarColors, useSidebarTheme } from '../styles/themeMode';
import { antGrey } from '../styles/globalStyles';

interface StepItemLinkContainerProps {
    isActive?: boolean;
    isSubStep?: boolean;
    isParentSectionActive?: boolean;
    isLastNode?: boolean;
    hasIcon?: boolean;
    isHovered?: boolean;
    children: React.ReactNode;
}

export const StepItemLinkContainer = ({
    isActive = false,
    isSubStep = false,
    isParentSectionActive = false,
    isLastNode = false,
    hasIcon = false,
    isHovered = false,
    children,
}: StepItemLinkContainerProps) => {
    const sc = useSidebarColors();
    const themeMode = useSidebarTheme();
    let backgroundColor = 'transparent';
    if (isSubStep) {
        if (isHovered) {
            backgroundColor = themeMode === 'light' ? antGrey.grey5 : sc.menuHoverBg;
        } else if (isParentSectionActive) {
            backgroundColor = sc.stepChildrenActiveBg;
        }
    } else {
        if (isActive) {
            backgroundColor = sc.menuActiveBg;
        } else if (isHovered) {
            backgroundColor = sc.menuHoverBg;
        }
    }

    return (
        <div
            style={{
                backgroundColor,
                display: 'flex',
                justifyContent: hasIcon ? 'space-between' : 'flex-end',
                alignItems: 'center',
                paddingLeft: 16,
                paddingRight: 16,
                borderTop: isSubStep ? 'none' : `0.5px solid ${sc.border}`,
                borderBottom:
                    isSubStep ? 'none'
                    : isLastNode ? `0.5px solid ${sc.border}`
                    : 'none',
            }}
        >
            {children}
        </div>
    );
};

export const StepItemTextContainer = ({
    children,
    isSubStep = false,
}: {
    children: React.ReactNode;
    isSubStep?: boolean;
}) => {
    return (
        <div
            style={{
                display: 'flex',
                minWidth: 0,
                overflow: 'hidden',
                ...(isSubStep ? {} : { marginLeft: 4, marginRight: 10 }),
            }}
        >
            {children}
        </div>
    );
};

export const StepItemText = ({
    children,
    shouldBoldText = false,
    nonBlocking = false,
    isSubStep = false,
}: {
    children: React.ReactNode;
    shouldBoldText?: boolean;
    nonBlocking?: boolean;
    isSubStep?: boolean;
}) => {
    const sc = useSidebarColors();
    return (
        <Text
            style={{
                fontSize: isSubStep ? 12 : 14,
                textAlign: 'right',
                fontWeight: shouldBoldText ? 600 : 400,
                color: nonBlocking ? sc.textMuted : sc.text,
            }}
            ellipsis
        >
            {children}
        </Text>
    );
};
